<template>
    <submenu-page
        eyebrow="STUDENT PORTAL"
        title="Exam"
        description="Open available examinations and student exam tools."
        count-label="exam tools"
    >
        <Submenu />
    </submenu-page>
</template>
<script> 
  import Submenu from './Submenu.vue';
  export default {
    components: {
     Submenu
    },  
    data() {        
      return {       
        accessDetails: null,
      };
    },
    mounted(){      
      this.accessDetails = this.$store.getters['auth/_user'];
      if (this.accessDetails.isSchoolStudent == false) {
           if(this.accessDetails.SchoolId == null){
            this.$store.dispatch('auth/Logout')
            this.$router.push('/login')
           }
        }
    }   
  };
</script>
<style></style>
